module.exports = __webpack_public_path__ + "static/media/Comment.f66e1a1c.svg";